import { useEffect } from 'react';
import { Outlet } from 'react-router';
import { useBranding } from '@/lib/branding-context';

export function PrayLayout() {
  const { branding } = useBranding();

  useEffect(() => {
    const base = branding.appName || 'One Voice';
    document.title = `Pray With Us | ${base}`;

    // Drop any media-scoped theme-color tags so OS dark mode cannot tint the chrome.
    document.querySelectorAll('meta[name="theme-color"]').forEach((node) => {
      if (node instanceof HTMLMetaElement && node.hasAttribute('media')) {
        node.remove();
      }
    });
    let el = document.querySelector('meta[name="theme-color"]') as HTMLMetaElement | null;
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute('name', 'theme-color');
      document.head.appendChild(el);
    }
    el.setAttribute('content', '#f8fafc');
  }, [branding.appName]);

  return <Outlet />;
}
